import { Spinner, Card, CardHeader, CardBody } from "@heroui/react";
import React from "react";
import { useTranslation } from "react-i18next";

import { useOrg } from "@wc/domain/organizations";
import TeamMemberList from "@wc/domain/team-membership/components/team-member-list";
import { useTeam } from "@wc/domain/teams";
import TeamInfo from "@wc/domain/teams/components/team-info";
import SeeMoreLink from "@wc/ui/components/see-more-link";
import usePageTitle from "@wc/ui/hooks/page-title";

/**
 * @returns {React.ReactElement} The team overview page
 */
export default function TeamOverview() {
  const teamData = useTeam();
  const orgData = useOrg();
  const { t } = useTranslation();

  usePageTitle(teamData.team?.name || "");

  if (!teamData.team) {
    return (
      <div className="mt-8 flex justify-center">
        <Spinner color="primary" />
      </div>
    );
  }

  const baseUrl = `/orgs/${orgData.org?.id}/teams/${teamData.team?.id}`;

  return (
    <div className="m-5 flex flex-col gap-4">
      <Card className="m-5">
        <CardHeader className="flex items-center justify-between">
          <h2 className="text-xl font-bold">{t("team.tab-info")}</h2>
          <SeeMoreLink url={`${baseUrl}/info`} />
        </CardHeader>
        <CardBody>
          <TeamInfo />
        </CardBody>
      </Card>
      <Card className="m-5">
        <CardHeader className="flex items-center justify-between">
          <h2 className="text-xl font-bold">{t("team.tab-members")}</h2>
          <SeeMoreLink url={`${baseUrl}/members`} />
        </CardHeader>
        <CardBody>
          <TeamMemberList />
        </CardBody>
      </Card>
    </div>
  );
}
